module.exports = __webpack_public_path__ + "static/MinionPro-SemiboldCapt-a4d42fbc129c9c2c428a10582c44e970.woff";